<template>
<div class="view">
  <decorate></decorate>
  <div class="main record_page">
    <div class="nav">
      <div class="left">
        <router-link
          class="front icon_back"
          :to="{ path: '/', query: queryData }"
        ></router-link>
      </div>
      兑换记录
      <div class="record" @click="showRule = true">兑换规则</div>
    </div>
    <Scrapper class="scroll" ref="view">
      <div
        v-if="Object.keys(recordList).length > 0"
        v-for="(item, index) in homePage.exchange"
        :key="index"
        class="re_list"
      >
        <div class="mra">
          <div class="small">
            订单号：{{ item.number }}
            <span v-if="item.status == 1">未领取</span>
            <span v-if="item.status == 2">已领取</span>
            <span v-if="item.status == 3">未发货</span>
            <span v-if="item.status == 4">已发货</span>
          </div>
          <div class="flex_list">
            <div>
              <van-image class="post" :src="item.img" />
            </div>
            <div class="ma-left">
              <p class="big">{{ item.title }}</p>
              <p class="p">兑换数量：{{ item.item_number }}</p>
            </div>
          </div>
          <div class="xt" v-if="item.logistics"></div>
          <div class="flex_text" v-if="item.logistics">
            <p class="ma_bottom">
              快递公司：{{ item.logistics.logistic_name }}
            </p>
            <p>
              快递单号：{{ item.logistics.waybill_num }}
              <span>
                <button
                  class="btn"
                  type="button"
                  v-clipboard:copy="item.logistics.waybill_num"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                >
                  复制
                </button></span
              >
            </p>
          </div>
          <!-- <div class="flex_text" v-if="item.logistics === null">
                     <p class="ma_bottom">快递公司：虚拟物品无信息</p>   
                </div> -->
          <!-- <div class="detail">
                    <p class="big">{{item.title}}<span class="front icon_promo"></span></p>
                    <p class="p" v-if='item.type == 3'>折现金额：{{item.withdraw_amount}}元</p>
                    <p class="p" v-else>兑换数量：{{item.item_number}}</p>
                    <div class="small">订单号：{{item.number}}</div>
                </div> -->
          <!-- <div class="right">已领取</div> -->
        </div>
        <!-- <div class="right already_right" v-if="item.status == 2">已领取</div> -->
      </div>
      <div class="img_alt" v-if="Object.keys(recordList).length <= 0">
        <img src="../assets/images/no_rule.png" alt="" />
        <p>没有兑换记录</p>
      </div>
    </Scrapper>
    <div
      v-if="Object.keys(recordList).length > 0"
      class="front icon_consolt"
      @click="showConsolt = true"
    ></div>
    <van-popup class="connet_card" v-model="showConsolt" get-container="body">
      <div class="down">
        <div class="line" v-for="(item, index) in homePage.allocation.contact">
          <div class="front icon_qq"></div>
          <div slot="text" class="psw">
            <input type="text" disabled="disabled" v-model="item.value" />
          </div>
          <button
            class="btn"
            type="button"
            v-clipboard:copy="item.value"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            复制
          </button>
          <!-- <div class="btn">复制</div> -->
        </div>
        <div class="line" v-for="(item, index) in homePage.allocation.emall">
          <div class="front icon_mail"></div>
          <div slot="text" class="psw">
            <input type="text" disabled="disabled" v-model="item.value" />
          </div>
          <button
            class="btn"
            type="button"
            v-clipboard:copy="item.value"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            复制
          </button>
        </div>
      </div>
      <div class="front icon_close" @click="showConsolt = false"></div>
    </van-popup>
    <div class="van-overlay" v-show="showRule">
      <div class="layer_rule" v-for="(item, index) in homePage.allocation.rule">
        <p class="name">{{ item.title }}</p>
        <Scrapper class="scroll">
          {{ item.value }}
        </Scrapper>
      </div>
      <div class="front icon_close" @click="showRule = false"></div>
    </div>
  </div>
  </div>
</template>
<script>
import Scrapper from "./element/Scrapper";
import decorate from "./element/decorate";
import "../css/aside.scss";
import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
Vue.use(VueClipboard);
export default {
  components: { Scrapper ,decorate},
  data: function () {
    return {
      logistics: null,
      userId: "",
      showConsolt: false,
      showRule: false,
      recordList: {},
      topHeight: 0,
    };
  },
  computed: {
    ...mapState(["homePage"]),
  },
  watch: {
    //'$route': 'setNewsList'
  },
  created() {
    this.queryData = this.$route.query || {};
    this.topHeight = this.queryData.TopHeight;
    let obj = {
      userId: this.queryData.userId,
      appId: this.queryData.appId,
      uid: this.queryData.uid,
    };
    this.$store.dispatch("homePage/fetchExchange", obj).then((res) => {
      this.recordList = res.data;
      // console.log(this.recordList)
    });
    this.$store.dispatch("homePage/fetchAllocation", obj);
  },
  methods: {
    ...mapActions(["fetchHome"]),
    ...mapMutations([]),
    //复制功能
    onCopy: function (e) {
      alert("复制成功");
    },
    onError: function (e) {
      alert("复制失败");
    },
  },
  mounted() {},
};
</script>
